<!--
 * @Description  : 异常评价明细表
 * @Author       : chenJunHui
 * @LastEditors: chaoluandi chaoluandi@whty.com.cn
 * @Date         : 2022-09-06 14:02:57
 * @LastEditTime: 2024-12-10 10:11:34
 * @FilePath     : \after_class_service\src\pages\cloudMap\proupTable\courseAbnormal.vue
-->
<template>
  <div class="index">
    <template v-if="!show_detail">
    <div
          class="warn_item"
          v-for="(item, index) in tabtList"
          :class="{ on: item.val === tabVal }"
          :key="index + 'ycTab'"
          @click="tabClick(item)"
        >
          {{ item.lable }}
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%" border :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }">
        <el-table-column
          :label="org_type == '1' && !isSchool ? '学校名称' : '课程名称'"
          align="center"
        >
          <template slot-scope="scope">
            <p>
              {{
                org_type == "1" && !isSchool
                  ? scope.row.orga_name
                  : scope.row.course_name
              }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="abnormal_num"
          label="异常评价次数"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="toDetail(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="total"
          layout="total,prev, pager, next,jumper,sizes"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
        ></el-pagination>
      </div>
    </div>
    <!-- <download-excel class = "export-excel-wrapper" :data = "excelpage" :fields = "json_fields" name = "课程评价情况.xls" >
    		<a-button type="primary" icon="download"> 导出 </a-button>
    </download-excel> -->
    </template>
    <!-- 详情 -->
    <template v-if="show_detail">
      <el-table :data="tableData_2" style="width: 100%" border :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }">
        <template v-if="org_type=='1' && !isSchool">
        <el-table-column
          prop="course_name"
          label="课程名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="teacher_name"
          label="授课教师"
          align="center"
        >
        </el-table-column>
        </template>
        <!-- 校级 -->
        <template v-else>
          <el-table-column
          prop="eval_user"
          label="评价人"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <p>
              {{ scope.row.eval_user }}（）
            </p>
          </template> -->
        </el-table-column>
        <el-table-column
          prop="eval_class_name"
          label="所属班级"
          align="center"
        >
        </el-table-column>
        </template>
        <!-- <el-table-column
          prop="teacher_name"
          label="评分"
          align="center"
        >
        </el-table-column> -->
        <el-table-column
          prop="content"
          label="评价内容"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- <download-excel class = "export-excel-wrapper" :data = "tableData_2" :fields = "json_fields_2" name = "课程评价明细.xls" >
    		<a-button type="primary" icon="download"> 导出 </a-button>
      </download-excel> -->
    </template>
  </div>
</template>
<script>
import cloudMapApi from "@/api/cloudMapApi.js";
import { mapMutations, mapState } from "vuex";
export default {
  props: ["selectParmam", "evaTab"],
  components: {  },
  data() {
    return {
      tableData: [],
      tableData_2: [],
      pageSize: 10,
      total: 0,
      pageNum: 1,
      org_type: sessionStorage.org_type, // 1:教育局, 2:学校, 8:机构
      show_detail: false,
      excelpage:[],    // 存放用于导出excel的数据
      json_fields: {
        '学校名称': "orga_name",    //常规字段
        '异常评价次数': "abnormal_num", //支持嵌套属性
      },
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 "
          }
        ]
      ],
      json_fields_2: {
        '课程名': "course_name",
        '授课教师': "teacher_name",
        "评价内容": "content",
      },
      tabtList: [
        { lable: "昨天", val: 1 },
        { lable: "近7日", val: 7 },
        { lable: "近30日", val: 30 },
      ],
      tabVal: 1,
      id: '',
      name: '',
      num: 0,
      course_name: '',
      course_id: '',
    };
  },
  computed: {
    ...mapState(["isSchool"]),
  },
  created() {
    if(this.org_type=='1' && !this.isSchool){
      this.json_fields= {
        '学校名称': "orga_name",
        '异常评价次数': "abnormal_num",
      }
      this.json_fields_2={
        '课程名': "course_name",
        '授课教师': "teacher_name",
        "评价内容": "content",
      }
    }else{
      this.json_fields= {
        '课程名称': "course_name",
        '异常评价次数': "abnormal_num",
      }
      this.json_fields_2={
        '评价人': "eval_user",
        '所属班级': "eval_class_name",
        "评价内容": "content",
      }
    }
    this.tabVal= this.evaTab;
    this.getAbnormalAppraise();
  },
  watch: {
    selectParmam: function (n, o) {
      if(n){
        this.pageNum= 1;
        this.getAbnormalAppraise();
      }
    },
  },
  methods: {
    tabClick(item) {
      if(item != this.tabVal){
        this.tabVal = item.val;
        this.pageNum = 1;
        this.getAbnormalAppraise();
      }
    },
    // 异常评价预警
    async getAbnormalAppraise() {
      try {
        let params = {
          ...JSON.parse(JSON.stringify(this.selectParmam)),
          date: this.tabVal,
          pagenum: this.pageNum,
          pagesize: this.pageSize,
        };
        params.topic = params.topic === "校" ? "课程" : "学校";
        let res = await cloudMapApi.abnormalAppraise(params);
        if (res.code == "0") {
          this.tableData = res.data.rows;
          this.total = res.data.total;
          this.getExlData();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getExlData(){
      try {
        let params = {
          ...JSON.parse(JSON.stringify(this.selectParmam)),
          date: this.tabVal,
          pagenum: this.pageNum,
          pagesize: this.total,
        };
        params.topic = params.topic === "校" ? "课程" : "学校";
        let res = await cloudMapApi.abnormalAppraise(params);
        if (res.code == "0") {
          this.excelpage = res.data.rows || [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async toDetail(item){
      this.id= item.orga_id,
      this.name= item.orga_name,
      this.num= item.abnormal_num,
      this.course_name= item.course_name,
      this.course_id= item.course_id;
      this.getList();
      this.show_detail = true;
    },
    async getList() {
      try {
        let params = {
          date: this.tabVal,
          orga_id: this.id,
          orga_name: this.name,
          pagenum: 1,
          pagesize: this.num,
        };
        if (this.selectParmam.topic == "校") {
          params.course_name = this.course_name;
          params.course_id = this.course_id;
        }
        let res = await cloudMapApi.abnormalAppraiseDetail(params);
        if (res.code == "0") {
          this.tableData_2 = res.data.rows;
        }
      } catch (err) {
        console.log(err);
      }
    },
    sizeChangeHandle(val) {
			this.pageSize = val
			this.getAbnormalAppraise()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getAbnormalAppraise()
		},

  },
};
</script>
<style lang="less" scoped>
.index {
   position: relative;
  .warn_item {
      display: inline-block;
      cursor: pointer;
      font-size: 12px;
      color: #beddff;
      width: 66px;
      height: 30px;
      background: #eff7ff;
      border: 1px solid #beddff;
      border-radius: 24px;
      margin-right: 1%;
      color: #3997ff;
      text-align: center;
      line-height: 30px;
      &.on {
        background: #3997ff;
        color: #fff;
      }
  }
  .no_data {
    text-align: center;
    margin: 20px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>